var exports = {
  "uF": "Mascot__MgPHZq",
  "iK": "Animate__fuG4zT",
  "_V": "Image__g1FhhB",
  "Vo": "Shadow__5vTSV6",
};

module.exports = exports;
